import isNil from 'lodash/isNil'
import { DateTime, DateTimeFormatPreset, DurationLike } from 'luxon'

export const DATE_SHORT = DateTime.DATE_SHORT
export const DATETIME_SHORT = DateTime.DATETIME_SHORT
export const DATETIME_FULL = DateTime.DATETIME_FULL

// TODO CHANGE with IntlFormattedDate
export function formatTime(
  milliseconds?: number | null,
  format: DateTimeFormatPreset = DateTime.DATE_SHORT
) {
  if (isNil(milliseconds)) {
    return null
  }

  return DateTime.fromMillis(milliseconds).toLocaleString(format)
}

export function addTime(milliseconds: number, duration: DurationLike) {
  return DateTime.fromMillis(milliseconds).plus(duration)
}

export function formatTimeFromSQL(
  time: string,
  format: DateTimeFormatPreset = DateTime.DATETIME_FULL
) {
  const date = DateTime.fromSQL(time)
  if (!date.isValid) {
    return time
  }

  return date.toLocaleString(format)
}
